export const LAT_LNG_REGEX = /(-)?\d+.\d+[,;]\s?(-)?\d+.\d+/;
export const LAT_REGEX = /^(-)?\d{1,2}[,.]\d+$/;
export const LNG_REGEX = /^(-)?\d{1,3}[,.]\d+$/;
export const WEATHER_STATION_SERIAL = /^([ACDFHLRU]{2}[1-4,6-9]{2}){2}$/;
